import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

export const APP_ROLE_SYNC_RESOURCE = "app-role" as const;
export const APP_ROLE_SYNC_API_PATH = `/v1/${APP_ROLE_SYNC_RESOURCE}` as const;

export type AppRoleSyncBody = paths[typeof APP_ROLE_SYNC_API_PATH]["put"]["requestBody"]["content"]["application/json"];
export type AppRoleSyncResponse =
  paths[typeof APP_ROLE_SYNC_API_PATH]["put"]["responses"][200]["content"]["application/json"];

export const useAppRoleSyncMutation = (): UseMutationResult<AppRoleSyncResponse, Error, AppRoleSyncBody> => {
  const queryClient = useQueryClient();

  return useMutation<AppRoleSyncResponse, Error, AppRoleSyncBody>({
    mutationFn: async (payload: AppRoleSyncBody) => {
      const response = await alphartisApiAxios.put<AppRoleSyncResponse>(APP_ROLE_SYNC_API_PATH, payload);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [APP_ROLE_SYNC_RESOURCE] });
    },
  });
};
